var map = {
	"./win-sign.json": 129,
	"./win-sign@2x.json": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;



//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/win\-sign.*\.json$
// module id = 186
// module chunks = 3